
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import Widget from '@/components/Widget/Widget.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import BillboardPreset from '@/models/BillboardPreset'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import ModelFileUploader from '@/components/ModelFile/ModelFileUploader.vue'
import FilePicker from '@/components/FilePicker/FilePicker.vue'
import RegionPicker from '@/components/RegionPicker/RegionPicker.vue'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import Billboard from '@/models/Billboard'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import BillboardPresetPicker from '@/components/Billboard/BillboardPresetPicker.vue'
// @ts-ignore
import CKEditor from '@ckeditor/ckeditor5-vue2'
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

@Component({
  components: {
    FormInput,
    Widget,
    SelectPicker,
    IconAction,
    ModelFileUploader,
    FilePicker,
    RegionPicker,
    CompanyPicker,
    ckeditor: CKEditor.component,
    CheckboxInput,
    FooterNav,
    BillboardPresetPicker,
  },
})
export default class BillboardEdit extends ViewModel {
  @Ref() public validator!: any

  public billboard: Billboard = new Billboard()

  public ready: boolean = false

  public importing_file: boolean = false

  public loading: boolean = false

  public image_preview: any = null

  public image: any = null

  public enable_remote_access: boolean = false

  public editor = ClassicEditor

  @Watch('image')
  public onChangeImage() {
    if (this.image) {
      const reader = new FileReader()
      reader.onloadend = () => {
        this.image_preview = reader.result
      }
      reader.readAsDataURL(this.image)
    } else if (this.image_preview) {
      this.image_preview = null
    }
  }

  public get previewMode() {
    return this.$route.query && this.$route.query.mode && this.$route.query.mode === 'preview'
  }

  public get pageTitle() {
    if (this.$route.params.id) return 'Billboard  Edit'
    return 'New Billboard'
  }

  public mounted() {
    if (this.$route.params.id) {
      this.loadBillboardById()
    } else {
      this.ready = true
      this.loading = false
    }
  }

  public loadBillboardById() {
    this.loading = true
    Billboard.find(this.$route.params.id)
      .then(response => {
        this.billboard = response
        this.ready = true
        this.loading = false
      })
      .catch(error => {
        this.ready = true
        this.loading = false
      })
  }

  public save() {
    this.loading = true
    this.billboard
      .save()
      .then(response => {
        this.loading = false
        if (response.status === 200) {
          this.$router.push({ name: 'billboards' })
        }
      })
      .catch(error => {
        this.loading = false
      })
  }
}
